<template>
    <div class="content">
        <div class="title">
            智慧教育
            <div class="line"></div>
        </div>
        <div class="con2">
            <p>智慧教育一体机</p>
            <p>智慧白板</p>
            <el-button>详情</el-button>
        </div>
    </div>

</template>

<script>
  export default {
    name: "SmartEducation"
  }
</script>

<style scoped lang="less">
    .content {
        padding-top: 60px;
        height: 720px;
        background: url(../../assets/img/page5bg.jpg) no-repeat;
        background-size: 100% 100%;
    }

    .title {
        padding-top: 20px;
        text-align: center;
        font-size: 34px;
        color: #595757;
    }

    .line {
        width: 103px;
        background: #e5d276;
        height: 4px;
        margin: 10px auto;
    }

    .con2 {
        width: 100%;
        height: 342px;
        background: rgba(127, 93, 128, 0.76);
        margin-top: 130px;
        padding-top: 106px;
        text-align: center;

        > p {
            font-size: 40px;
            color: #f4f4f6;
        }

        .el-button {
            border: none;
            width: 142px;
            height: 56px;
            border-radius: 14px;
            background: rgba(229, 210, 118, 0.7);
            font-size: 26px;
            color: #f4f4f6;
            margin-top: 80px;
        }
    }
</style>
